<main id="login-wrapper">
  <mat-card>
    <div class="d-flex justify-content-center mb-3">
      <img src="assets/logo-1280-206.png" class="logo">
    </div>

    <h1 class="text-center">Log in</h1>

    <form [formGroup]="loginForm">
      <mat-form-field>
        <input
          matInput
          formControlName="email"
          placeholder="Email"
          type="email"
          autocomplete="email">
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          formControlName="password"
          placeholder="Password"
          type="password"
          autocomplete="current-password">
      </mat-form-field>

      <button
        mat-flat-button
        (click)="login()"
        [disabled]="!loginForm.valid || authenticating"
        color="primary">{{ authenticating ? 'Working...' : 'Submit' }}</button>
    </form>

    <p id="error-message" class="has-text-danger">{{ errorMessage }}</p>

    <hr>

    <a routerLink="/reset-password" class="anchor">Reset your password</a>
  </mat-card>
</main>
